module.exports = __webpack_public_path__ + "img/lg_ring_g_e_null_0@2x.195fe515.png";